import CONTROLLERS from '@/features/operations/components/pages/MapView/components/LayersMenu/legends/controllers.svg'
import CONTROLLERS_C from '@/features/operations/components/pages/MapView/components/LayersMenu/legends/controllers_c.svg'
import ISOLATION_VALVE from '@/features/operations/components/pages/MapView/components/LayersMenu/legends/isolation_valve.svg'
import WEATHER_STATIONS from '@/features/operations/components/pages/MapView/components/LayersMenu/legends/weather_stations.svg'
import SOIL_MOISTURE_SENSOR from '@/features/operations/components/pages/MapView/components/LayersMenu/legends/soil_moisture_sensor.svg'
import FLOW_SENSOR from '@/features/operations/components/pages/MapView/components/LayersMenu/legends/flow_sensor.svg'
import TEMP_SENSOR from '@/features/operations/components/pages/MapView/components/LayersMenu/legends/temp_sensor.svg'
import CUSTOM_MARKERS from '@/features/operations/components/pages/MapView/components/LayersMenu/legends/custom_markers.svg'
import INTERFACE_NAME from '@/features/operations/components/pages/MapView/components/LayersMenu/legends/interface_name.svg'
import SENSOR_STATION_ERROR from '@/features/operations/components/pages/MapView/components/LayersMenu/legends/sensor_stations_error.svg'
import SENSOR_STATION_NORMAL from '@/features/operations/components/pages/MapView/components/LayersMenu/legends/sensor_station_normal.svg'
import SENSOR_STATION_NOT_REACHABLE from '@/features/operations/components/pages/MapView/components/LayersMenu/legends/sensor_station_not_reachable.svg'
import VALVE_ON from '@/features/operations/components/pages/MapView/components/LayersMenu/legends/valve_on.svg'
import VALVE_OFF from '@/features/operations/components/pages/MapView/components/LayersMenu/legends/valve_off.svg'
import VALVE_ERROR from '@/features/operations/components/pages/MapView/components/LayersMenu/legends/valve_error.svg'
import VALVE_WAITING from '@/features/operations/components/pages/MapView/components/LayersMenu/legends/valve_waiting.svg'
import VALVE_OFF_LOADING from '@/features/operations/components/pages/MapView/components/LayersMenu/legends/valve_off_loading.svg'

export enum ELegendName {
  CONTROLLERS = 'Controllers',
  ISOLATION_VALVE = 'Isolation Valve',
  WEATHER_STATIONS = 'Weather Stations',
  SOIL_MOISTURE_SENSOR = 'Soil Moisture Sensor',
  FLOW_SENSOR = 'Flow Sensor',
  TEMP_SENSOR = 'Temp Sensor',
  CUSTOM_MARKERS = 'Custom Markers',
  INTERFACE_NAME = 'Interface Name',
  SENSOR_STATION_ERROR = 'Sensor Station Error',
  SENSOR_STATION_NORMAL = 'Sensor Station Normal',
  SENSOR_STATION_NOT_REACHABLE = 'Sensor Station Not Reachable',
  VALVE_ON = 'Valve ON',
  VALVE_OFF = 'Valve OFF',
  VALVE_ERROR = 'Valve ERROR',
  VALVE_WAITING = 'Valve WAITING',
  DEFAULT_ICON = 'Custom Markers',
  VALVE_OFF_LOADING = 'Valve OFF Loading',
}

export const ELegendIcon = {
  [ELegendName.CONTROLLERS]: CONTROLLERS_C,
  [ELegendName.ISOLATION_VALVE]: ISOLATION_VALVE,
  [ELegendName.WEATHER_STATIONS]: WEATHER_STATIONS,
  [ELegendName.SOIL_MOISTURE_SENSOR]: SOIL_MOISTURE_SENSOR,
  [ELegendName.FLOW_SENSOR]: FLOW_SENSOR,
  [ELegendName.TEMP_SENSOR]: TEMP_SENSOR,
  [ELegendName.CUSTOM_MARKERS]: CUSTOM_MARKERS,
  [ELegendName.INTERFACE_NAME]: INTERFACE_NAME,
  [ELegendName.SENSOR_STATION_ERROR]: SENSOR_STATION_ERROR,
  [ELegendName.SENSOR_STATION_NORMAL]: SENSOR_STATION_NORMAL,
  [ELegendName.SENSOR_STATION_NOT_REACHABLE]: SENSOR_STATION_NOT_REACHABLE,
  [ELegendName.VALVE_ON]: VALVE_ON,
  [ELegendName.VALVE_OFF]: VALVE_OFF,
  [ELegendName.VALVE_ERROR]: VALVE_ERROR,
  [ELegendName.VALVE_WAITING]: VALVE_WAITING,
  [ELegendName.VALVE_OFF_LOADING]: VALVE_OFF_LOADING,
}

interface ILegendSVG {
  name: ELegendName
  alt?: string
  className?: string
}

const getFormattedFileName = (legendName: ELegendName): string => {
  return legendName.toLowerCase().replace(/\s+/g, '_') + '.svg'
}

export const LegendSVGLoader = ({
  name,
  alt = 'SVG Icon',
  className = '',
}: ILegendSVG) => {
  const formattedName = getFormattedFileName(name)
  try {
    const SvgIcon = ELegendIcon[name]
    return <img src={SvgIcon} alt={alt} className={className} />
  } catch (error) {
    console.error(`Error loading SVG: ${formattedName}`, error)
    return <span>&nbsp;</span>
  }
}

interface LegendIconByNameProps {
  name: ELegendName
}

export const LegendIconByName: React.FC<LegendIconByNameProps> = ({ name }) => {
  if (!Object.values(ELegendName).includes(name as ELegendName)) {
    return <span></span>
  }
  return <LegendSVGLoader name={name} />
}
